import Alpine from 'alpinejs';
import initHeader from './components/Header';
import initVideoImageSlider from './blocks/VideoImageSlider';
import initVideoBanner from './blocks/VideoBanner';
import initRankingStrip from './blocks/RankingStrip';
import initStatisticsStrip from './blocks/StatisticsStrip';
import initIntroCtaCards from './blocks/IntroCtaCards';
import initIntroCtaEntriesCards from './blocks/IntroCtaEntriesCards';
import initInsight from './pages/insights/Insight';
import initForms from './utils/Forms';
import initInsightCategory from './pages/insights/InsightCategory';
import initTabs from './components/Tabs';
import initStyles from './components/JsStyles';
import initProgramsCards from './blocks/ProgramsCards';
import initSubProgramsCards from './blocks/SubProgramsCards';
import initInformation from './blocks/Information';
import initInformationCardsGrid from './blocks/InformationCardsGrid';
import initBenefitCards from './blocks/BenefitCards';
import initTestimonials from './blocks/Testimonials';
import initVideoCard from './blocks/VideoCard';
import initInfoVideo from './blocks/InfoVideo';
import initImageSlider from './blocks/ImageSlider';
import initAccordion from './components/Accordion';
import initDocumentCardsBrochure from './blocks/DocumentCardsBrochure';
import initGridOfGeneralFullCards from './blocks/GridOfGeneralFullCards';
import initOutsourceLinkCards from './blocks/OutsourceLinkCards';
import initCounterAndChartCard from './components/CounterAndChartCard';
import initProgressBarDash from './components/ProgressBarDash';
import initOutsourceLinkFullCards from './blocks/OutsourceLinkFullCards';
import initPartnerSchoolsStrip from './blocks/PartnerSchoolsStrip';
import initGridOfCustomStaffCards from './blocks/GridOfCustomStaffCards';
import initStaffCardsGrid from './blocks/StaffCardGrid';
import initTables from './utils/Tables';
import initInformationSustainableCards from './blocks/InformationSustainableCards';
import initInfoHoverCards from './blocks/InfoHoverCards';
import initGridOfCustomAccreditationCards from './blocks/GridOfCustomAccreditationCards';
import initInformationImagesSlider from './blocks/InformationImagesSlider';
import initGridOfDocumentsCards from './blocks/GridOfDocumentsCards';
import initAccreditationCards from './blocks/AccreditationCards';
import initDocumentCards from './blocks/DocumentCards';

window.Alpine = Alpine;

document.addEventListener('alpine:init', () => {
  initStyles();
  initHeader();
  initVideoImageSlider();
  initVideoBanner();
  initRankingStrip();
  initStatisticsStrip();
  initIntroCtaCards();
  initIntroCtaEntriesCards();
  initInsight();
  initInsightCategory();
  initForms();
  initTables();
  initTabs();
  initProgramsCards();
  initSubProgramsCards();
  initInformation();
  initInformationCardsGrid();
  initBenefitCards();
  initTestimonials();
  initVideoCard();
  initInfoVideo();
  initImageSlider();
  initAccordion();
  initDocumentCardsBrochure();
  initGridOfGeneralFullCards();
  initOutsourceLinkCards();
  initCounterAndChartCard();
  initProgressBarDash();
  initOutsourceLinkFullCards();
  initPartnerSchoolsStrip();
  initGridOfCustomStaffCards();
  initStaffCardsGrid();
  initInformationSustainableCards();
  initInfoHoverCards();
  initGridOfCustomAccreditationCards();
  initInformationImagesSlider();
  initGridOfDocumentsCards();
  initAccreditationCards();
  initDocumentCards();
});
Alpine.start();
